export const SET_FILTERS = "SET_FILTERS";
export const SET_FILTER_TYPES = "SET_FILTER_TYPES";
export const SET_ITEM_FILTER = "SET_ITEMFILTER";
export const SET_FILTERED_ITEMS = "SET_FILTERED_ITEMS";
export const SET_FILTERED_MENU = "SET_FILTERED_MENU";
